export type UiLanguage = 'en' | 'id';

const id: Record<string, string> = {
  Reader: 'Pembaca',
  Guide: 'Panduan',
  Settings: 'Pengaturan',
  Preferences: 'Preferensi',
  Theme: 'Tema',
  Language: 'Bahasa',
  system: 'Sistem',
  light: 'Terang',
  dark: 'Gelap',
  en: 'English',
  id: 'Indonesia',
  'Thumbnail size': 'Ukuran thumbnail',
  'Grid density': 'Kepadatan grid',
  'Default view': 'Tampilan default',
  'Default zoom': 'Zoom default',
  'Remember session': 'Ingat sesi',
  'Subtle animations': 'Animasi halus',
  'Reader minimap': 'Peta mini pembaca',
  'Double-click fullscreen': 'Klik ganda layar penuh',
  compact: 'Ringkas',
  medium: 'Sedang',
  large: 'Besar',
  comfortable: 'Nyaman',
  'fit-width': 'Pas lebar',
  'fit-height': 'Pas tinggi',
  'fit-page': 'Pas halaman',
  actual: 'Ukuran asli',
  Reading: 'Membaca',
  'Document navigation': 'Navigasi dokumen',
  'Rotate left': 'Putar kiri',
  'Rotate right': 'Putar kanan',
  'Add named bookmark': 'Tambah bookmark bernama',
  'Choose favorite collection': 'Pilih koleksi favorit',
  'Enter fullscreen': 'Masuk layar penuh',
  'Exit fullscreen': 'Keluar layar penuh',
  'Previous page': 'Halaman sebelumnya',
  'Next page': 'Halaman berikutnya',
  'First page': 'Halaman pertama',
  'Zoom out': 'Perkecil',
  'Zoom in': 'Perbesar',
  'Previous PDF': 'PDF sebelumnya',
  'Next PDF': 'PDF berikutnya',
  'Add bookmark': 'Tambah bookmark',
  'Bookmark name': 'Nama bookmark',
  Cancel: 'Batal',
  Save: 'Simpan',
  'Add to favorites': 'Tambahkan ke favorit',
  'Choose one or more collections': 'Pilih satu atau beberapa koleksi',
  Done: 'Selesai',
  'Create a favorite collection from Navigation first.':
    'Buat koleksi favorit dari Navigasi terlebih dahulu.',
  Navigation: 'Navigasi',
  Document: 'Dokumen',
  'Library synchronization': 'Sinkronisasi library',
  Outline: 'Daftar isi',
  'This document has no outline.': 'Dokumen ini tidak memiliki daftar isi.',
  'Bookmarked pages': 'Halaman yang ditandai',
  'Bookmark pages to find them here.': 'Tandai halaman agar mudah ditemukan di sini.',
  'Favorite collections': 'Koleksi favorit',
  'Create a collection to group favorite PDFs.': 'Buat koleksi untuk mengelompokkan PDF favorit.',
  'No PDFs in this collection.': 'Belum ada PDF dalam koleksi ini.',
  Go: 'Buka',
  Library: 'Library',
  All: 'Semua',
  'No documents found': 'Dokumen tidak ditemukan',
  'No PDFs in this collection': 'Belum ada PDF dalam koleksi ini',
  'Try a different search or open a PDF.': 'Coba pencarian lain atau buka PDF.',
  'Use the heart icon in the reader to add PDFs.':
    'Gunakan ikon hati di pembaca untuk menambahkan PDF.',
  Recent: 'Terbaru',
  'Search documents…': 'Cari dokumen…',
  'Sort library': 'Urutkan library',
  'Open local PDF': 'Buka PDF lokal',
  'Refresh library': 'Muat ulang library',
  'Fullscreen reader': 'Pembaca layar penuh',
  'PDF Manager': 'Pengelola PDF',
  'Manage libraries': 'Kelola library',
  'More actions': 'Tindakan lainnya',
  'Clear search': 'Hapus pencarian',
  'Sync libraries': 'Sinkronkan library',
  'Add favorite page': 'Tambah halaman favorit',
  'Choose bookmark collections': 'Pilih koleksi bookmark',
  'Add to bookmarks': 'Tambahkan ke bookmark',
  'Select one or more bookmark collections': 'Pilih satu atau beberapa koleksi bookmark',
  'Bookmark collections': 'Koleksi bookmark',
  'Add bookmark collection': 'Tambah koleksi bookmark',
  'Favorite pages': 'Halaman favorit',
  'Favorite pages to find them here.': 'Favoritkan halaman agar mudah ditemukan di sini.',
  'Hidden PDFs': 'PDF tersembunyi',
  'No hidden PDFs.': 'Tidak ada PDF tersembunyi.',
  'Hide PDF': 'Sembunyikan PDF',
  Refresh: 'Muat ulang',
  Fullscreen: 'Layar penuh',
  'Recently opened': 'Terakhir dibuka',
  Newest: 'Terbaru',
  Oldest: 'Terlama',
  'Largest file': 'File terbesar',
  'Smallest file': 'File terkecil',
  'Page count': 'Jumlah halaman',
  'Favorites first': 'Favorit dahulu',
  'Your reading space is ready.': 'Ruang baca Anda sudah siap.',
  'Select a document from the library to continue reading. Your position, named bookmarks, and favorites stay synchronized across devices.':
    'Pilih dokumen dari library untuk mulai membaca. Posisi, bookmark bernama, dan favorit tetap tersinkron di semua perangkat.',
  Documents: 'Dokumen',
  Favorites: 'Favorit',
  Bookmarks: 'Bookmark',
  'Open first document': 'Buka dokumen pertama',
  'Preparing document': 'Menyiapkan dokumen',
  'Loading pages and thumbnails…': 'Memuat halaman dan thumbnail…',
  'Fit width': 'Pas lebar',
  'Fit page': 'Pas halaman',
  'Reset zoom': 'Atur ulang zoom',
  'Google Drive': 'Google Drive',
  'Connected accounts': 'Akun terhubung',
  'Connect multiple Google accounts. Client credentials remain on this server.':
    'Hubungkan beberapa akun Google. Kredensial client tetap tersimpan di server ini.',
  'What should I enter?': 'Apa yang harus diisi?',
  'Use a Web application OAuth client from Google Cloud Console.':
    'Gunakan OAuth client bertipe Web application dari Google Cloud Console.',
  'Open Google Cloud credentials': 'Buka kredensial Google Cloud',
  'Save OAuth configuration': 'Simpan konfigurasi OAuth',
  'Connect another Google account': 'Hubungkan akun Google lain',
  'Library account': 'Akun library',
  'Public read-only': 'Publik hanya-baca',
  Security: 'Keamanan',
  'Change PIN': 'Ganti PIN',
  'Current PIN': 'PIN saat ini',
  'New PIN': 'PIN baru',
  'Recovery Gmail': 'Gmail pemulihan',
  'Use a Google App Password, not your normal Gmail password.':
    'Gunakan Google App Password, bukan kata sandi Gmail biasa.',
  'Save recovery email': 'Simpan email pemulihan',
  'Personal PDF workspace': 'Ruang kerja PDF pribadi',
  'Create your PIN': 'Buat PIN Anda',
  'Welcome back': 'Selamat datang kembali',
  'Reset your PIN': 'Atur ulang PIN',
  'Enter reset code': 'Masukkan kode reset',
  'Protect DS-PDF on every connected device.':
    'Lindungi DS-PDF pada setiap perangkat yang terhubung.',
  'Enter your personal PIN to continue.': 'Masukkan PIN pribadi untuk melanjutkan.',
  'Forgot PIN?': 'Lupa PIN?',
  'Unlock DS-PDF': 'Buka DS-PDF',
  'Create PIN': 'Buat PIN',
  'Send reset code': 'Kirim kode reset',
  'Set new PIN': 'Simpan PIN baru',
  'Back to login': 'Kembali ke login',
  'Your libraries': 'Library Anda',
  'Public Google Drive folders': 'Folder Google Drive publik',
  'No login or API key. Folders must be shared as “Anyone with the link”.':
    'Tanpa login atau API key. Folder harus dibagikan sebagai “Siapa saja yang memiliki link”.',
  Libraries: 'Library',
  Active: 'Aktif',
  Synced: 'Tersinkron',
  'Add library': 'Tambah library',
  'Auto sync': 'Sinkronisasi otomatis',
  'Sync now': 'Sinkronkan sekarang',
  'Rename library': 'Ganti nama library',
  'Delete library': 'Hapus library',
  Enabled: 'Aktif',
  Paused: 'Dijeda',
  On: 'Nyala',
  Off: 'Mati',
  'Add public folder': 'Tambah folder publik',
  'Library name': 'Nama library',
  optional: 'opsional',
  'Folder URL or ID': 'URL atau ID folder',
  'Auto sync interval': 'Interval sinkronisasi otomatis',
  'Add and sync library': 'Tambah dan sinkronkan library',
  'Google Drive workspace': 'Ruang kerja Google Drive',
  History: 'Riwayat',
  'Activity Log': 'Log Aktivitas',
  Accounts: 'Akun',
  'Search managed PDFs': 'Cari PDF yang dikelola',
  'All libraries': 'Semua library',
  'Upload PDF': 'Unggah PDF',
  'Recent history': 'Riwayat terbaru',
  'No reading history yet.': 'Belum ada riwayat membaca.',
  'No operations logged.': 'Belum ada operasi yang tercatat.',
  'No Google accounts connected.': 'Belum ada akun Google yang terhubung.',
  'Activity log': 'Log aktivitas',
  'Open Google Drive': 'Buka Google Drive',
  'Copy file name': 'Salin nama file',
  'Name copied': 'Nama tersalin',
  Rename: 'Ganti nama',
  Delete: 'Hapus',
  'No matching PDFs.': 'Tidak ada PDF yang cocok.',
  'DS-PDF Documentation': 'Dokumentasi DS-PDF',
  Contents: 'Daftar isi',
  'Google OAuth': 'Google OAuth',
  'Accounts & libraries': 'Akun & library',
  Synchronization: 'Sinkronisasi',
  Errors: 'Error',
  Setup: 'Persiapan',
  'Google OAuth configuration': 'Konfigurasi Google OAuth',
  'Multi-account': 'Multi-akun',
  'Assign accounts to libraries': 'Hubungkan akun ke library',
  'File management': 'Pengelolaan file',
  'Reader, bookmarks, and favorites': 'Pembaca, bookmark, dan favorit',
  Troubleshooting: 'Pemecahan masalah',
  'Error handling': 'Penanganan error',
  'Official links': 'Tautan resmi',
  Resources: 'Sumber daya',
  Copy: 'Salin',
  'OAuth is required only for uploading, renaming, or deleting files in Google Drive. Reading folders shared publicly continues to work without OAuth.':
    'OAuth hanya diperlukan untuk mengunggah, mengganti nama, atau menghapus file di Google Drive. Folder publik tetap dapat dibaca tanpa OAuth.',
  'If DS-PDF is hosted under a domain, replace localhost with the public HTTPS API address, for example:':
    'Jika DS-PDF menggunakan domain, ganti localhost dengan alamat HTTPS API publik, contohnya:',
  'and create or select a project.': 'lalu buat atau pilih project.',
  ', then click': ', lalu klik',
  'Complete Branding, Audience, and Data Access. For a personal Gmail account, use External and add your Gmail as a test user while the app is in testing.':
    'Lengkapi Branding, Audience, dan Data Access. Untuk Gmail pribadi, pilih External dan tambahkan Gmail Anda sebagai test user selama aplikasi masih dalam mode testing.',
  ', choose': ', pilih',
  ', then select': ', lalu pilih',
  Under: 'Pada bagian',
  ', enter the callback URL exactly as shown below.':
    ', masukkan callback URL persis seperti di bawah ini.',
  'Copy the generated Client ID and Client Secret.':
    'Salin Client ID dan Client Secret yang dihasilkan.',
  'In DS-PDF, open': 'Di DS-PDF, buka',
  'Paste Client ID, Client Secret, and the same callback URL, then press':
    'Tempel Client ID, Client Secret, dan callback URL yang sama, lalu tekan',
  Press: 'Tekan',
  'and approve the requested Drive access.': 'dan setujui akses Drive yang diminta.',
  'Connect every Google account from Settings.': 'Hubungkan setiap akun Google dari Pengaturan.',
  'Under Library account, select the account that owns or can edit each folder.':
    'Pada Akun library, pilih akun yang memiliki atau dapat mengedit setiap folder.',
  'The account must have Editor permission. “Anyone with the link — Viewer” is read-only.':
    'Akun harus memiliki izin Editor. “Siapa saja yang memiliki link — Viewer” hanya dapat membaca.',
  'Choose Public read-only if the library should only use public synchronization.':
    'Pilih Publik hanya-baca jika library hanya menggunakan sinkronisasi publik.',
  ': search, filter by library, upload, copy filename, open Drive link, rename, and permanently delete files.':
    ': cari, filter berdasarkan library, unggah, salin nama, buka link Drive, ganti nama, dan hapus file permanen.',
  ': recently opened PDFs with their library and access time.':
    ': PDF yang terakhir dibuka beserta library dan waktunya.',
  ': successful operations and detailed errors.': ': operasi berhasil dan detail error.',
  ': a short list of connected Google accounts.': ': daftar singkat akun Google yang terhubung.',
  'Select a PDF card to open it. Page, zoom, rotation, and scroll position are restored automatically.':
    'Pilih kartu PDF untuk membukanya. Halaman, zoom, rotasi, dan posisi scroll dipulihkan otomatis.',
  'Use the heart icon to save multiple named favorite pages.':
    'Gunakan ikon hati untuk menyimpan banyak halaman favorit bernama.',
  'Use the bookmark icon to add the current PDF to one or more bookmark collections.':
    'Gunakan ikon bookmark untuk menambahkan PDF aktif ke satu atau beberapa koleksi bookmark.',
  'Bookmark collections appear as filters above the Library grid and inside Navigation. Favorite pages are available from Navigation.':
    'Koleksi bookmark tampil sebagai filter di atas grid Library dan di dalam Navigasi. Halaman favorit tersedia dari Navigasi.',
  'Fullscreen provides previous/next PDF according to the currently selected sort order.':
    'Layar penuh menyediakan PDF sebelumnya/berikutnya sesuai urutan yang dipilih.',
  'Public libraries are scanned without an API key.': 'Library publik dipindai tanpa API key.',
  'New, renamed, modified, and removed PDFs are detected independently per library.':
    'PDF baru, berganti nama, berubah, dan terhapus dideteksi secara terpisah pada setiap library.',
  'Sync progress is visible in Navigation and Library Management.':
    'Progres sinkronisasi terlihat di Navigasi dan Pengelolaan Library.',
  'Only modified files regenerate thumbnails.':
    'Hanya file yang berubah yang membuat ulang thumbnail.',
  'Upload through PDF Manager adds the PDF immediately; later sync confirms Drive state.':
    'Unggah melalui Pengelola PDF langsung menambahkan PDF; sinkronisasi berikutnya memastikan status Drive.',
  'The callback URL in Google Cloud is different from Settings. Copy it exactly.':
    'Callback URL di Google Cloud berbeda dari Pengaturan. Salin persis sama.',
  'Authorization was cancelled, the Gmail is not a test user, or the consent screen blocks access.':
    'Otorisasi dibatalkan, Gmail belum menjadi test user, atau consent screen memblokir akses.',
  'The refresh token expired or was revoked. Reconnect the affected Google account.':
    'Refresh token kedaluwarsa atau dicabut. Hubungkan ulang akun Google terkait.',
  'The connected account cannot edit the selected Drive folder.':
    'Akun yang terhubung tidak dapat mengedit folder Drive terpilih.',
  'Public synchronization requires Anyone with the link access, even when no OAuth account is assigned.':
    'Sinkronisasi publik memerlukan akses Siapa saja yang memiliki link, meskipun tidak ada akun OAuth.',
  'for the operation, timestamp, file, and backend error. Server errors are also printed in the terminal running':
    'untuk melihat operasi, waktu, file, dan error backend. Error server juga dicetak di terminal yang menjalankan',
  'A redirect URI must match exactly, including protocol, port, path, and trailing slash. A mismatch produces redirect_uri_mismatch.':
    'Redirect URI harus sama persis, termasuk protokol, port, path, dan garis miring akhir. Perbedaan akan menghasilkan redirect_uri_mismatch.',
  'Tokens are encrypted on the DS-PDF server. If Google revokes a token, its status changes to Reconnect required.':
    'Token dienkripsi di server DS-PDF. Jika Google mencabut token, statusnya berubah menjadi Perlu dihubungkan ulang.',
  'Open the database icon in the main toolbar. The manager contains four full-width tabs:':
    'Buka ikon database di toolbar utama. Pengelola memiliki empat tab selebar halaman:',
  'Delete removes the original Google Drive file. This cannot be undone from DS-PDF.':
    'Hapus akan menghapus file asli Google Drive. Tindakan ini tidak dapat dibatalkan dari DS-PDF.',
};

export function translateUi(value: string, language: UiLanguage) {
  if (language === 'en') return value;
  const direct = id[value];
  if (direct) return direct;
  const patterns: Array<[RegExp, (...values: string[]) => string]> = [
    [/^(\d+) documents$/, (count) => `${count} dokumen`],
    [/^(\d+) pages$/, (count) => `${count} halaman`],
    [/^Page (\d+)$/, (page) => `Halaman ${page}`],
    [/^Rendering page (\d+)$/, (page) => `Merender halaman ${page}`],
    [/^Page (\d+) waiting$/, (page) => `Halaman ${page} menunggu`],
    [/^(\d+) PDFs$/, (count) => `${count} PDF`],
    [/^Delete (.+)$/, (name) => `Hapus ${name}`],
    [/^Rename (.+)$/, (name) => `Ganti nama ${name}`],
  ];
  for (const [pattern, format] of patterns) {
    const match = value.match(pattern);
    if (match) return format(...match.slice(1));
  }
  return value;
}
